export const DIALOGS = {
	UPLOAD_DW_DIALOG: {
		id: "0cc9dbce-be42-423a-bd5e-9376d445fa22",
		render: (dialogTitle, body) => {},
	},
};
